module.exports = __webpack_public_path__ + "static/media/favicon-72.a36d859d.png";